<template>
  <div class="heading">
    <div class="heading__info">
      <img v-if="level == 1" src="@/assets/images/icon-gift-colored.svg">
      <img v-if="level == 3" src="@/assets/images/icon-customize-colored.svg">

      <div>
        <h2 class="heading__title">{{ title }}</h2>
        <p class="heading__subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <a class="heading__help-link" href="https://componata.de/so-funktioniert-es-componata/" target="_blank">
      <span class="o-question-mark-icon">
        <i class="icon icon-question-circle"></i>
      </span>
      <span>So funktioniert es</span>
    </a>
  </div>
</template>

<script>

export default {
  name: 'Heading',
  props: {
    title: {
      type: String,
      default: 'Configurator'
    },
    subtitle: {
      type: String,
      default: 'Configurator'
    },
    level: {
      type: [String, Number],
      default: 1
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Heading
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Header for the steps of the configurator
 * @since 2020-04-28
**/

$component: 'heading';

.#{$component} {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @include margin-bottom(map-get($spacers, 3));
  @include padding-top(map-get($spacers, 3));

  &__info {
    display: flex;
    align-items: center;

    > img {
      @include rfs(2.4rem, width);
      height: auto;
      @include margin-right(map-get($spacers, 2));
    }
  }

  &__title {
    margin: 0;
    @include margin-bottom(map-get($spacers, 1));
  }

  &__subtitle {
    margin: 0;
  }

  // Help link
  &__help-link {
    color: $ink-lightest;
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &:hover .o-question-mark-icon {
      color: $ink-lighter;
    }

    .o-question-mark-icon {
      @include margin-top(map-get($spacers, 1));
      @include margin-right(map-get($spacers, 1));
    }
  }

  // ——————————————————————————————
  // Mobile Max SM
  // ——————————————————————————————
  @include media-breakpoint-down(sm) {
    padding-top: 0;

    &__help-link span:not(.o-question-mark-icon) {
      display: none;
    }

    &__help-link .o-question-mark-icon {
      margin: 0;
    }
  }
}
</style>
